import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button/Button";
import './Buses.scss';

export default function Buses() {
    const [stopId, setStopId] = useState('');
    const navigate = useNavigate();

    const search = () => {
        if (!stopId.trim()) return;
        navigate(`/bus/${stopId.trim()}`);
    };

    return (
        <div id="buses">
            <div className='centered-container'>
                <br />
                <h2>Buses</h2>
                <div className="buses-search">
                    <input
                        type="number"
                        placeholder="Stop Number"
                        value={stopId}
                        onChange={e => setStopId(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && search()}
                        autoFocus
                    />
                    <Button text="Search" onClick={search} />
                </div>
            </div>
        </div>
    );
}
